var _defs, _g, _rect, _rect2, _path, _line, _line2, _line3, _path2, _line4, _line5, _path3, _line6, _line7, _line8, _path4, _path5, _line9, _line10, _line11, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetartrantBidon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bidon_d\\xE9tartrage",
    "data-name": "bidon d\\xE9tartrage",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1116.23 1733",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-7,.cls-8,.cls-9{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#eee8e8;}.cls-4{fill:#efeded;}.cls-5{fill:#a89892;}.cls-6{fill:#f7f7f7;}.cls-7{stroke:#d04439;stroke-width:17px;}.cls-7,.cls-8,.cls-9{stroke-miterlimit:10;}.cls-8,.cls-9{stroke:#000;}.cls-8{stroke-width:2px;}.cls-10{fill:#233e82;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-441.93 -108)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1558,542c-3-13-42-96-42-96l-18-174c-10.64-63.5-51-112-113-112l-424,2c-21,.45-37.41,12.09-52,28,0,0-61,90-63,92s-33,19-33,19H776V275c-1.76-4.43-8-6.64-16-8,0,0-2-76.59-2-78,.93-33.19-250.07-40.19-251-7v80l-8,1c-8.76-.26-9.76,33.74-1,34v10c-4.86,2.44-8.55,7.07-11,14,0,0-6,94-10,121s-33,81-35,115,42,1120,42,1120,4,70,31,100c61,61,106,59,158,58s339-6,339-6c78-1,347,10,347,10,101.76-4.49,157.42-55.48,163-157C1522,1682,1561,555,1558,542ZM1339,368c-10.43,14.16-25.65,24.75-56,24L977,346c-14.4-5.59-23.93-17.47-26-39,.39-30.66,16.23-47.62,44-54l315-3c32.39,6.66,51.42,24,51,57Z"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "D\xE9tartrant cubis") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1558,544c-3-13-42-96-42-96l-18-174c-10.64-63.5-51-112-113-112l-424,2c-21,.45-37.41,12.09-52,28,0,0-61,90-63,92s-33,19-33,19H776V277c-1.76-4.43-8-6.64-16-8,0,0-2-76.59-2-78,.93-33.19-250.07-40.19-251-7v80l-8,1c-8.76-.26-9.76,33.74-1,34v10c-4.86,2.44-8.55,7.07-11,14,0,0-6,94-10,121s-33,81-35,115,42,1120,42,1120,4,70,31,100c61,61,106,59,158,58s339-6,339-6c78-1,347,10,347,10,101.76-4.49,157.42-55.48,163-157C1522,1684,1561,557,1558,544ZM1339,370c-10.43,14.16-25.65,24.75-56,24L977,348c-14.4-5.59-23.93-17.47-26-39,.39-30.66,16.23-47.62,44-54l315-3c32.39,6.66,51.42,24,51,57Z",
    transform: "translate(-441.93 -108)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M460,447s-21,61,54,61H1558l-44-400L878,146,775,304c-110.88-6-229.83-15.23-277,4l-26,11Z",
    transform: "translate(-441.93 -108)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M951,309s-59-81-19-108,446-20,446-20c55.34,8.73,87.6,39.79,99,91v37s-134-24-139-26S951,309,951,309Z",
    transform: "translate(-441.93 -108)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 165.07,
    y: 682,
    width: 752,
    height: 819
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 880,
    y: 1191.25,
    width: 224.51,
    height: 224.51,
    transform: "translate(770.4 -427.84) rotate(45)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M976.11,1322.33H879.24V1308h43c0,4.24,13.64,4.24,13.64,0h40.18Z",
    transform: "translate(-441.93 -108)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 480.36,
    y1: 1199.98,
    x2: 466.01,
    y2: 1171.28
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 487.53,
    y1: 1187.43,
    x2: 487.53,
    y2: 1142.58
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 494.71,
    y1: 1192.81,
    x2: 509.06,
    y2: 1171.28
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M983.28,1238c8.38,0,8.38,14.35,0,14.35l-53.81,2.68v-13.45Z",
    transform: "translate(-441.93 -108)"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 489.62,
    y1: 1146.95,
    x2: 547.53,
    y2: 1138.54
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 614.89,
    y1: 1187.43,
    x2: 614.89,
    y2: 1142.58
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1003,1238c-8.38,0-8.38,14.35,0,14.35l53.82,2.68v-13.45Z",
    transform: "translate(-441.93 -108)"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 612.8,
    y1: 1146.95,
    x2: 554.89,
    y2: 1138.54
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 605.92,
    y1: 1185.63,
    x2: 591.57,
    y2: 1156.93
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 620.27,
    y1: 1178.46,
    x2: 634.62,
    y2: 1156.93
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1087.32,1325.92h-7.17q-.18,5.36-7.18,5.38h-39.46l-3.59-5.38h-5.38l-1.8-7.17h-5.38v-9h5.38v-7.18h14.35v-7.17s28.71-1.8,32.29,5.38h17.94Z",
    transform: "translate(-441.93 -108)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1064,1317s-9-3.58-10.76-10.76l-16.15-5.38",
    transform: "translate(-441.93 -108)"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 580.81,
    y1: 1201.78,
    x2: 598.75,
    y2: 1201.78
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 580.81,
    y1: 1210.75,
    x2: 602.34,
    y2: 1210.75
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 587.99,
    y1: 1217.92,
    x2: 605.92,
    y2: 1217.92
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M752,973V893.44h15V973Zm7.55,0V958.52h19.09q7.38,0,11.43-3.58t4-10V921.5q0-6.51-4-10.07t-11.43-3.55H759.59V893.44h18.76q15,0,23.16,7.47t8.17,21v22.53a30.62,30.62,0,0,1-3.5,14.91,24,24,0,0,1-10.47,10q-7,3.58-17.42,3.59Z",
    transform: "translate(-441.93 -108)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M824.45,973V893.44h15V973Zm5.41-65.08V893.44h47.85v14.44Zm0,32.81V926.25H871.7v14.44Zm0,32.27V958.52h47.85V973Z",
    transform: "translate(-441.93 -108)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M882.64,907.88V893.44h58.29v14.44ZM904.29,973V900h15v73Z",
    transform: "translate(-441.93 -108)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M937.11,973l30.4-79.52H977l30.4,79.52H991.3l-19-54.31-19,54.31Zm14.6-12.75V945.78h41.83v14.43Z",
    transform: "translate(-441.93 -108)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1017.28,973V893.39h15V973Zm6-32V926.53h27.67a6.91,6.91,0,0,0,5.61-2.57,10.66,10.66,0,0,0,2.16-6.78,10.42,10.42,0,0,0-2.11-6.79,6.94,6.94,0,0,0-5.66-2.57h-27.67V893.39h28.87a22.15,22.15,0,0,1,11.57,3,20,20,0,0,1,7.68,8.31,29.9,29.9,0,0,1,0,25.05,20.4,20.4,0,0,1-7.69,8.31,22,22,0,0,1-11.54,3Zm36,32L1040,938.5l16-2.51,21.43,37Z",
    transform: "translate(-441.93 -108)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1079.35,907.88V893.44h58.29v14.44ZM1101,973V900h15v73Z",
    transform: "translate(-441.93 -108)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1172.1,929.37h46.59v13.89H1172.1Zm30.51-15.26v44.41h-14.43V914.11Z",
    transform: "translate(-441.93 -108)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M849.85,1046v-42.6h4.22V1046Zm4,0v-3.93h9.64q5.93,0,8.86-2.77t3-8.33v-12.54q0-5.57-3-8.33t-8.86-2.77h-9.64v-3.93h9.47q8.14,0,12.17,3.81t4,11.46v12.07a17.83,17.83,0,0,1-1.81,8.48,11.49,11.49,0,0,1-5.4,5.08,21.16,21.16,0,0,1-9,1.7Z",
    transform: "translate(-441.93 -108)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M901.09,1046.48q-6.36,0-9.84-3.56t-3.49-10.06v-3.43q0-6.79,3.35-10.52t9.45-3.72q5.75,0,8.89,3.66t3.15,10.34v3.49h-22v-3.81h18v-.29q0-4.51-2.13-7a7.45,7.45,0,0,0-6-2.47,8.3,8.3,0,0,0-6.56,2.6q-2.31,2.61-2.31,7.39V1033q0,4.58,2.46,7.08a9.28,9.28,0,0,0,6.94,2.5,10.45,10.45,0,0,0,4.17-.88,11.31,11.31,0,0,0,3.68-2.49l2.87,2.76a16.15,16.15,0,0,1-5,3.35A14.51,14.51,0,0,1,901.09,1046.48Zm-.82-36.71-2.58-2,8.38-10.4,3.14,2.61Z",
    transform: "translate(-441.93 -108)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M918.46,1019.26v-3.63h13.71v3.63Zm10.26,26.93c-2.5,0-4.31-.7-5.44-2.08a9.32,9.32,0,0,1-1.68-6v-31.35h4.22v31.41a4.57,4.57,0,0,0,.88,3,3.17,3.17,0,0,0,2.6,1.07h2.87v3.93Z",
    transform: "translate(-441.93 -108)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M950.1,1046.48c-3.55,0-6.31-.82-8.26-2.46a8.59,8.59,0,0,1-2.93-7,8.37,8.37,0,0,1,2.7-6.66q2.68-2.36,7.56-2.36h10.1l.41,3.93H949.2a6.86,6.86,0,0,0-4.53,1.33,5.09,5.09,0,0,0,.41,7.76,9.7,9.7,0,0,0,5.67,1.42,18.35,18.35,0,0,0,6.09-.79c1.45-.52,2.17-1.27,2.17-2.22l.62,4a7.71,7.71,0,0,1-2.33,1.64,13.84,13.84,0,0,1-3.24,1A21.22,21.22,0,0,1,950.1,1046.48ZM959,1046v-19.28a7.89,7.89,0,0,0-2-5.73,7.49,7.49,0,0,0-5.61-2,13.1,13.1,0,0,0-4.22.7,12.55,12.55,0,0,0-3.72,2l-3.07-2.11a11.44,11.44,0,0,1,4.55-3.23,16.5,16.5,0,0,1,6.29-1.16q5.7,0,8.84,3t3.14,8.35V1046Z",
    transform: "translate(-441.93 -108)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M972.31,1046v-30.41h4.22V1046Zm17.9-25a6,6,0,0,0-2.36-1.47,10,10,0,0,0-3.29-.49,8.14,8.14,0,0,0-5.94,2,7.51,7.51,0,0,0-2.09,5.62l-.62-5.86a12.1,12.1,0,0,1,4.37-4.22,12,12,0,0,1,6-1.52,11.15,11.15,0,0,1,3.76.6,8.48,8.48,0,0,1,3,1.77Z",
    transform: "translate(-441.93 -108)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M995.57,1019.26v-3.63h13.71v3.63Zm10.26,26.93c-2.5,0-4.32-.7-5.44-2.08a9.32,9.32,0,0,1-1.68-6v-31.35h4.22v31.41a4.62,4.62,0,0,0,.87,3,3.2,3.2,0,0,0,2.61,1.07h2.87v3.93Z",
    transform: "translate(-441.93 -108)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1017.49,1046v-30.41h4.22V1046Zm17.9-25a6,6,0,0,0-2.36-1.47,10.05,10.05,0,0,0-3.3-.49,8.11,8.11,0,0,0-5.93,2,7.48,7.48,0,0,0-2.09,5.62l-.62-5.86a12,12,0,0,1,4.37-4.22,11.88,11.88,0,0,1,5.94-1.52,11.21,11.21,0,0,1,3.77.6,8.44,8.44,0,0,1,2.94,1.77Z",
    transform: "translate(-441.93 -108)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1052.82,1046.48q-5.34,0-8.26-2.46a8.56,8.56,0,0,1-2.93-7,8.39,8.39,0,0,1,2.69-6.66q2.7-2.36,7.56-2.36H1062l.41,3.93h-10.49a6.89,6.89,0,0,0-4.53,1.33,5.11,5.11,0,0,0,.41,7.76,9.7,9.7,0,0,0,5.67,1.42,18.46,18.46,0,0,0,6.1-.79c1.44-.52,2.16-1.27,2.16-2.22l.62,4a7.59,7.59,0,0,1-2.33,1.64,13.84,13.84,0,0,1-3.24,1A21.19,21.19,0,0,1,1052.82,1046.48Zm8.9-.44v-19.28a7.88,7.88,0,0,0-2-5.73,7.49,7.49,0,0,0-5.61-2,13,13,0,0,0-4.22.7,12.31,12.31,0,0,0-3.72,2l-3.08-2.11a11.41,11.41,0,0,1,4.56-3.23,16.45,16.45,0,0,1,6.28-1.16q5.71,0,8.85,3t3.13,8.35V1046Z",
    transform: "translate(-441.93 -108)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1075,1046v-30.41h4.21V1046Zm20.21,0v-18.43a8.76,8.76,0,0,0-2.12-6.27,7.91,7.91,0,0,0-6-2.22,8.08,8.08,0,0,0-5.82,2,7.4,7.4,0,0,0-2.07,5.61l-.61-5.86a9.65,9.65,0,0,1,4.44-4.39,14.2,14.2,0,0,1,6-1.26,9.44,9.44,0,0,1,7.66,3.24c1.81,2.15,2.71,5.21,2.71,9.15V1046Z",
    transform: "translate(-441.93 -108)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1106.2,1019.26v-3.63h13.71v3.63Zm10.25,26.93c-2.5,0-4.31-.7-5.43-2.08a9.26,9.26,0,0,1-1.69-6v-31.35h4.22v31.41a4.57,4.57,0,0,0,.88,3,3.19,3.19,0,0,0,2.61,1.07h2.87v3.93Z",
    transform: "translate(-441.93 -108)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M507,262s147-18,253,5c15-17-.59-22.12-.59-22.12-93.19-12-178.89-14-252.41,0Z",
    transform: "translate(-441.93 -108)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M498,307c68.71-15.63,170.57-12.4,278-6v-5.29c-79.7-7.88-159.76-15.55-278,.29Z",
    transform: "translate(-441.93 -108)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetartrantBidon);
export default __webpack_public_path__ + "static/media/detartrant_bidon.fb019b2e8219ec9965398588c5a90a12.svg";
export { ForwardRef as ReactComponent };